import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { OffClickDirective } from '@df/module-off-click/off-click.directive';
import { ToggleModule } from '@df/ui/toggle/toggle.module';
import { NToggle, ToggleService } from '@df/ui/toggle/toggle.service';
import { InputWrapBodyDirective } from '../../ui/form/input-wrap-body.directive';
import { InputWrapComponent } from '../../ui/form/input-wrap.component';
import { MuiInputDirective } from '../../ui/form/mui-input.directive';

@Component({
    selector: 'custom-dropdown',
    templateUrl: './custom-dropdown.component.html',
    styleUrl: './custom-dropdown.component.scss',
    standalone: true,
    imports: [FormsModule, InputWrapBodyDirective, InputWrapComponent, MuiInputDirective, OffClickDirective, ToggleModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CustomDropdownComponent {
    @Input()
    tables = [];

    @Input()
    dropdownLabel: string = '';

    @Input()
    selectedCustomTable?: string;

    @Input()
    customTableToggleId: NToggle.TId = ['customTable', 0];

    @Output() selectedCustomTableChange = new EventEmitter<string>();

    protected toggleService = inject(ToggleService);

    get customTableSelectState() {
        return this.toggleService.getState(this.customTableToggleId);
    }

    onCustomTableModelChange(): void {
        this.selectedCustomTableChange.emit(this.selectedCustomTable);
    }

    selectCustomTable(title: string): void {
        this.selectedCustomTable = title;
        this.selectedCustomTableChange.emit(this.selectedCustomTable);
        this.closeCustomTableSelect();
    }

    toggleCustomTableSelect(): void {
        this.toggleService.toggle(this.customTableToggleId);
    }

    closeCustomTableSelect(): void {
        this.toggleService.close(this.customTableToggleId);
    }
}
